export const dataHooks = {
  input: 'checkbox-input',
  label: 'checkbox-label',
  boxTooltip: 'checkbox-box-tooltip',
  box: 'checkbox-box',
  children: 'checkbox-children',
} as const;

export const LABEL_TEXT_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
} as const;

export const SELECTION_AREA = {
  NONE: 'none',
  HOVER: 'hover',
  ALWAYS: 'always',
} as const;

export const V_ALIGN = {
  CENTER: 'center',
  TOP: 'top',
} as const;

export const SELECTION_AREA_SKIN = {
  FILLED: 'filled',
  OUTLINED: 'outlined',
} as const;
